export default {
    active: true,
    seed: 92,
    skyType: "gradient",
    skyColor: "#1ea84a",
    horizonColor: "#177132",
    lighting: "distant",
    lightPosition: { x: 0.5, y: 1, z: 0 },
    fog: 0.8,
    flatShading: false,
    playArea: 1,
    ground: "canyon",
    groundYScale: 9.76,
    groundTexture: "none",
    groundColor: "#851f31",
    groundColor2: "#912235",
    dressing: "hexagons",
    dressingAmount: 20,
    dressingColor: "#c7415b",
    dressingScale: 20,
    dressingVariance: { x: 20, y: 200, z: 20 },
    dressingUniformScale: false,
    dressingOnPlayArea: 0,
    grid: "crosses",
    gridColor: "#1ea84a",
    shadow: false,
};
